import { usePrimateAuth } from './usePrimateAuth'

/**
 * Provides a fetchToken() wrapper that returns the default Clerk session token
 * for API calls. Used throughout PrimateVisionV2Inner.
 *
 * PRI-371: this previously tried a Clerk JWT template named "supabase" first and
 * fell back to the default token. That template does NOT exist in either Clerk
 * instance, so every call logged a 404 (`No JWT template exists with name:
 * supabase`) to the console — alarming testers/investors — before silently
 * falling back. The API authenticates the DEFAULT Clerk session token
 * (@clerk/backend verifyToken, keyed off the user id), so the templated call was
 * pure cost + console noise. We now call getToken() directly.
 */
export function useAuthToken() {
  const { getToken } = usePrimateAuth()

  const fetchToken = async (): Promise<string | null> => {
    if (!getToken) return null
    try {
      return await getToken().catch(() => null)
    } catch {
      return null
    }
  }

  return { fetchToken }
}
